import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { liveCategories } from "@/mocks/lives";

export default function CategorySection() {
  return (
    <section className="w-full border-y border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="Categories"
        title="按现场类型找信号"
        desc="不同事件的镜头语言并不相同。先选一个你关心的现场类型，我们按信号状态与热度为你排好顺序。"
      />

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-10 md:gap-5">
        {liveCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/live?category=${encodeURIComponent(cat.name)}`}
            className="group flex cursor-pointer flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-500/60"
          >
            <div className="flex items-start justify-between gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100/60 text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="font-label text-[11px] text-foreground-500">
                {cat.count} 场
              </span>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-500">
              {cat.name}
            </h3>
            <p className="text-[13px] leading-relaxed text-foreground-600">{cat.desc}</p>
            <span className="mt-1 inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] text-foreground-700 transition-colors group-hover:text-primary-500">
              进入该分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}